import { getTradingReaderFacet } from '@ui/services/contract/contract-instances/getTradingReaderFacet';
import { Address } from '@ui/types/alias';
import { ChainId } from '@ui/types/chain';
import { PublicClient } from 'viem';

import { toMarketInfo } from './toMarketInfo';
import { ContractMarketInfo, MarketInfo } from './types';

export type { ContractMarketInfo, MarketInfo };

export const getMarketInfosQuery = {
  getQueryKey: ({
    pairBases,
    clientUid,
  }: {
    pairBases: Address[];
    clientUid: string;
  }) => ['TradingReaderFacet.getMarketInfosV2', pairBases.join(','), clientUid],
  getQueryFn:
    ({
      pairBases,
      client,
      chainId,
    }: {
      pairBases: Address[];
      client?: PublicClient;
      chainId: ChainId;
    }) =>
    async () => {
      if (!client) {
        throw new Error('Client missing');
      }
      const result = await getTradingReaderFacet({
        publicClient: client,
        chainId,
      })?.read.getMarketInfosV2([pairBases]);

      return result.map((v) => toMarketInfo(v));
    },
};
